'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Circle = exports.Line = undefined;

var _src = require('./src/');

var _src2 = _interopRequireDefault(_src);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.Line = _src.Line;
exports.Circle = _src.Circle; // based on rc-progress 2.5.2

exports['default'] = _src2['default'];